import classNames from "classnames";
import { FC, HTMLAttributes } from "react";

type ColsCount = 1 | 2 | 3 | 4;

interface FormGridProps extends HTMLAttributes<HTMLDivElement> {
    cols: ColsCount;
    mdCols?: ColsCount;
    lgCols?: ColsCount;
}

const colsClasses: Record<ColsCount, string> = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
};

const mdColsClasses: Record<ColsCount, string> = {
    1: "md:grid-cols-1",
    2: "md:grid-cols-2",
    3: "md:grid-cols-3",
    4: "md:grid-cols-4",
};

const lgColsClasses: Record<ColsCount, string> = {
    1: "lg:grid-cols-1",
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
};

export const FormGrid: FC<FormGridProps> = ({ cols, mdCols, lgCols, className, children, ...props }) => {
    return (
        <div
            className={classNames(
                "grid gap-3 [&_.ant-form-item]:mb-0",
                colsClasses[cols],
                mdCols && mdColsClasses[mdCols],
                lgCols && lgColsClasses[lgCols],
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
};
